import React from 'react'
import BaseLayout from '../../layouts/BaseLayout'
import Header from '../../components/ui-kit/header/Header'
import AlgoliaSearchBar from '../../components/algolia/AlgoliaSearch'

const Index = () => {
  return (
    <BaseLayout title="Proyectos" search={false} seo={{
      id: null,
      keywords: "programacion,proyectos,codealo,frontend,backend,python,java",
      metaTitle: "Proyectos | Codealo",
      metaDescription: "Encuentra los proyectos para tu portafolio.",
      preventIndexing: false,
      shareImage: null
    }}>
      <div className="flex bg-solid-blue flex-row rounded-lg p-4 lg:p-6 mb-8">
        <div className="lg:pr-8">
          <Header as="h3" className="text-highlight-yellow">Crea un portafolio profesional</Header>
          <p className="text-white mb-4">Usando los proyectos de Codealo vas a poder crear un portafolio donde muestras tus conocimientos como programador. Esto es sumamente importante cuando estás buscando trabajo.</p>
          {/* <p className="">
            <Link href="/blog/que-es-un-portafolio">
              <a>
                <span role="img" aria-details="thinking emoji">🤔</span><span className="text-highlight-yellow underline ml-1">¿Qué es un portafolio?</span>
              </a>
            </Link>
          </p> */}
        </div>
      </div>
      <Header as="h4" className="mb-2">Busca tu próximo proyecto</Header>
      <AlgoliaSearchBar index="PROJECT" />
    </BaseLayout>
  )
}

export default Index